/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/12
 * Time: 10:08
 */
<template>
  <div id='page2' class="page2">
    <div class="realBigTitle"></div>
    <div class="carousel-container gallery-0" id="gallery-0">
      <sp-carousel :trigger="isTriggerVisible" :interval="1000" id="c1" :update="update">
        <sp-carousel-item v-for="(item, index) in images" :key="index">
          <img v-lazy="item" :alt="index">
        </sp-carousel-item>
      </sp-carousel>
      <div class="item-cover"></div>
      <div class="page2-nav">
        <span class="_1st"  @click.stop="litRouter(1)"></span>
        <span class="_2st"  @click.stop="litRouter(2)"></span>
        <span class="_3st"  @click.stop="litRouter(3)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from '../components/simple/sp-carousel'
import item from '../components/simple/sp-carousel-item'
// import img from '../assets/images/index/page2/section2-image01.png'
import img from '../assets/images/index-mb/page2/section2-image01.jpg'

import { mapMutations } from 'vuex'
export default {
  name: 'page2',
  data () {
    return {
      images: [img, img, img, img],
      imgType: 1,
      isTriggerVisible: false,
      update: false
    }
  },
  components: {
    'sp-carousel': carousel,
    'sp-carousel-item': item
  },
  methods: {
    ...mapMutations([
      'setLoadVisible'
    ]),
    init () {
      if (!this.$lib.IsPC()) {
        this.imgType = 2
        // this.isTriggerVisible = true
      }
      this.initPage2Images()
    },
    async initPage2Images () {
      try {
        this.$http.get(`${this.$NODE_BASEURL}/slide?project_id=${this.$NODE_PROJECTID}`).then(res => {
          this.images = res.data.list.map(item => {
            return this.$lib.IsPC() ? item.pc_img : item.mobile_img
          })
        })
      } catch (e) {
        console.log('轮播图 err:', e)
      }
    },
    litRouter (index) {
      console.log(index)
      switch (index) {
        case 1:
        case 2:
          this.showGallery(index)
          break
        case 3:
          this.$router.push({ path: '/data' })
      }
    },
    showGallery (index) {
      let name = ''
      switch (index) {
        case 1:
          name = 'story'
          break
        case 2:
          name = 'roles'
          break
      }
      this.$emit('visibilityChange', name)
    }
  },
  created () {
    // page2 created
  },
  mounted () {
    // page2 mounted
    this.init()
    this.$lib.addC4M('page2', 'page2-mb')
    this.$lib.addC4M('gallery-0', 'gallery-0-mb')
    this.$lib.addC4Mac('page2', 'page2-Mac')
    this.$lib.addC4iPad('page2', 'page2-iPad')
  },
  updated () {
    // 当异步数据获取结束后，触发钩子函数，此时执行swiper更新操作
    this.update = true
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.page2 {
  //begin you code
  /*滚动条样式*/
  /*滚动条整体部分*/
  ::-webkit-scrollbar {
    display: none;
  }
  /*滚动条小方块*/
  ::-webkit-scrollbar-thumb {
    /*background-color: rgba(0, 0, 0, 0.6);*/
    /*height: .05rem;*/
    /*border-radius: .05rem;*/
    display: none;
  }
  /*滚动轨道两端按钮*/
  ::-webkit-scrollbar-button {
    display: none;
  }
  /*滚动轨道 内阴影*/
  ::-webkit-scrollbar-track {
    display: none;
  }
  background: url("../assets/images/index/bg/s2-bg.jpg") center top no-repeat;
  .realBigTitle {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 330px;
    height: 140px;
    background: url("../assets/images/index/bg/s2-bg-title.png") center top no-repeat;
    background-size: contain;
  }
  .carousel-container {
    width: 1006px;
    height: 507px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    .item-cover {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../assets/images/index/page2/section2-image.png") center top no-repeat;
      background-size: contain;
      pointer-events: none;
    }
    .page2-nav {
      width: 700px;
      height: 130px;
      background: url("../assets/images/index/page2/section2-btn-bg.png") center top no-repeat;
      background-size: contain;
      position: absolute;
      top: 545px;
      left: 50%;
      transform: translateX(-50%);
      padding: 25px 30px;
      span {
        display: inline-block;
        float: left;
        width: 194px;
        height: 80px;
        margin-right: 28px;
        transition: .3s;
        cursor: pointer;
        &:last-of-type {
          margin-right: 0;
        }
      }
      ._1st {
        background: url("../assets/images/index/page2/section2-btn01.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn01-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._2st {
        background: url("../assets/images/index/page2/section2-btn02.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn02-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._3st {
        background: url("../assets/images/index/page2/section2-btn03.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn03-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
  }
}
.page2-Mac {
  //begin you code
  background: url("../assets/images/index/bg/s2-bg.jpg") center top no-repeat;
  .realBigTitle {
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translateX(-50%) scale(.7);
    width: 330px;
    height: 140px;
    background: url("../assets/images/index/bg/s2-bg-title.png") center top no-repeat;
    background-size: contain;
  }
  .carousel-container {
    width: 1006px;
    height: 507px;
    position: relative;
    top: 50%;
    transform: translateY(-50%) scale(.7);
    margin: 0 auto;
    .item-cover {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../assets/images/index/page2/section2-image.png") center top no-repeat;
      background-size: contain;
      pointer-events: none;
    }
    .page2-nav {
      width: 700px;
      height: 130px;
      background: url("../assets/images/index/page2/section2-btn-bg.png") center top no-repeat;
      background-size: contain;
      position: absolute;
      top: 545px;
      left: 50%;
      transform: translateX(-50%);
      padding: 25px 30px;
      span {
        display: inline-block;
        float: left;
        width: 194px;
        height: 80px;
        margin-right: 28px;
        transition: .3s;
        cursor: pointer;
        &:last-of-type {
          margin-right: 0;
        }
      }
      ._1st {
        background: url("../assets/images/index/page2/section2-btn01.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn01-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._2st {
        background: url("../assets/images/index/page2/section2-btn02.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn02-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._3st {
        background: url("../assets/images/index/page2/section2-btn03.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index/page2/section2-btn03-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
    }
  }
}
.page2-mb {
  //begin you code
  background: url("../assets/images/index-mb/bg/s2-bg.jpg") center top no-repeat;
  background-size: 100% auto!important;
  .realBigTitle {
    position: absolute;
    top: 1.30rem;
    left: 50%;
    transform: translateX(-50%) scale(.7);
    width: 7.68rem;
    height: 2.00rem;
    background: url("../assets/images/index-mb/bg/s2-title.png") center top no-repeat;
    background-size: contain;
  }
  .carousel-container {
    width: 6.06rem;
    height: 6.06rem;
    position: relative;
    top: 52%;
    transform: translateY(-50%);
    margin: 0 auto;
    .item-cover {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../assets/images/index-mb/page2/section2-image.png") center top no-repeat;
      background-size: contain;
      pointer-events: none;
    }
    .page2-nav {
      width: 2.56rem;
      height: 1.30rem;
      background: none;
      background-size: contain;
      position: absolute;
      top: 6.65rem;
      left: 50%;
      transform: translateX(-50%);
      padding: 0;
      span {
        display: inline-block;
        float: left;
        width: 2.56rem;
        height: 1.30rem;
        margin-right: 0;
        transition: .3s;
        cursor: pointer;
        &:last-of-type {
          margin-right: 0;
        }
      }
      ._1st {
        background: url("../assets/images/index-mb/page2/section2-btn.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index-mb/page2/section2-btn-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._2st {
        display: none;
      }
      ._3st {
        display: none;
      }
    }
  }
}
.page2-iPad {
  //begin you code
  background: url("../assets/images/index-mb/bg/s2-bg.jpg") center top no-repeat;
  background-size: 100% auto!important;
  .realBigTitle {
    position: absolute;
    top: .60rem;
    left: 50%;
    transform: translateX(-50%) scale(.7);
    width: 7.68rem;
    height: 2.00rem;
    background: url("../assets/images/index-mb/bg/s2-title.png") center top no-repeat;
    background-size: contain;
  }
  .carousel-container {
    width: 6.06rem;
    height: 6.06rem;
    position: relative;
    top: 52%;
    transform: translateY(-50%) scale(.8);
    margin: 0 auto;
    .item-cover {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../assets/images/index-mb/page2/section2-image.png") center top no-repeat;
      background-size: contain;
      pointer-events: none;
    }
    .page2-nav {
      width: 2.56rem;
      height: 1.30rem;
      background: none;
      background-size: contain;
      position: absolute;
      top: 6.65rem;
      left: 50%;
      transform: translateX(-50%);
      padding: 0;
      span {
        display: inline-block;
        float: left;
        width: 2.56rem;
        height: 1.30rem;
        margin-right: 0;
        transition: .3s;
        cursor: pointer;
        &:last-of-type {
          margin-right: 0;
        }
      }
      ._1st {
        background: url("../assets/images/index-mb/page2/section2-btn.png") center top no-repeat;
        background-size: contain;
        &:hover {
          background: url("../assets/images/index-mb/page2/section2-btn-hover.png") center top no-repeat;
          background-size: contain;
        }
      }
      ._2st {
        display: none;
      }
      ._3st {
        display: none;
      }
    }
  }
}
</style>
<!-- 自定义swiper样式 -->
<style type="text/scss" lang="scss">
#gallery-0 {
  .simpleCarousel {
    .arrows-box {
      .arrow-forward{
        width: 61px;
        height: 121px;
        background: url("../assets/images/index/page2/section2-right.png") center top no-repeat;
        background-size: contain;
        border-radius: 0;
        border: 0;
        right: -145px;
      }
      .arrow-back{
        width: 61px;
        height: 121px;
        background: url("../assets/images/index/page2/section2-left.png") center top no-repeat;
        background-size: contain;
        border-radius: 0;
        border: 0;
        left: -145px;
      }
    }
  }
}
#gallery-0.gallery-0-mb {
  .simpleCarousel {
    .arrows-box {
      .arrow-forward{
        width: .52rem;
        height: 1.03rem;
        background: url("../assets/images/index-mb/page2/section2-right.png") center top no-repeat;
        background-size: contain;
        border-radius: 0;
        border: 0;
        right: -.65rem;
      }
      .arrow-back{
        width: .52rem;
        height: 1.03rem;
        background: url("../assets/images/index-mb/page2/section2-left.png") center top no-repeat;
        background-size: contain;
        border-radius: 0;
        border: 0;
        left: -.65rem;
      }
    }
    .button-box {
      bottom: -.50rem;
      .box {
        .button-item {
          width: .30rem;
          height: .30rem;
          border-radius: 50%;
          margin-right: .20rem;
          &:last-of-type {
            margin-right: 0;
          }
          .bar-white {
            width:100%;
            transform: scale(0);
            border-radius: 50%;
            background: #700200;
          }
          .bar-white-active {
            transform: scale(1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/index/page2.vue